module.exports = __webpack_public_path__ + "static/media/accountancy.d4ee90dd.svg";